import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
    customerNoteColor,
    deltekNoteColor,
    deltekNoteHoverColor,
    dialogActionHR,
    viewOnlyBackgroundColor,
    viewOnlyHeaderColor,
} from 'bpm/shared/bpmColors'
import { ListingNotesModalStyleProps } from './ListingNotesModal'

const useStyles = makeStyles((theme: Theme) => ({
    dialog: ({ isViewOnly }: ListingNotesModalStyleProps) => ({
        '& .MuiDialog-paperScrollPaper': {
            backgroundColor: !isViewOnly
                ? theme.palette.common.white
                : viewOnlyBackgroundColor,
            color: !isViewOnly
                ? viewOnlyHeaderColor
                : theme.palette.common.white,
            padding: theme.spacing(1.5),
        },
    }),
    dialogContent: {
        display: 'flex',
        minHeight: pxToRem(400),
        flexDirection: 'column',
        color: ({ isViewOnly }: ListingNotesModalStyleProps) =>
            !isViewOnly
                ? theme.palette.common.black
                : theme.palette.common.white,
        fontSize: pxToRem(18),
        padding: theme.spacing(1, 3, 3, 1.5),
        overflowY: 'auto',
        backgroundColor: 'inherit',
    },
    actionButton: {
        backgroundColor: deltekNoteColor,
        width: 'auto',
        minWidth: pxToRem(100),
        height: pxToRem(41),
        fontSize: pxToRem(18),
        color: theme.palette.common.white,
        borderRadius: 100,
        '&:hover': {
            backgroundColor: deltekNoteHoverColor,
        },
    },
    dialogAction: {
        '&.MuiDialogActions-root': {
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(2),
        },
    },
    detailText: {
        fontSize: pxToRem(11),
    },
    circularProgressCenter: {
        position: 'absolute',
        left: '50%',
        top: '50%',
    },
    emptyNotesContainer: {
        display: 'flex',
        width: '70%',
        margin: '0 auto',
        flexDirection: 'column',
        alignItems: 'center',
    },
    emptyNotesArrow: {
        display: 'flex',
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
        width: '100%',
    },
    emptyNotesDescription: {
        color: customerNoteColor,
        fontWeight: 'bold',
    },
    closeIcon: {
        color: ({ isViewOnly }: ListingNotesModalStyleProps) =>
            !isViewOnly
                ? theme.palette.common.black
                : theme.palette.common.white,
        position: 'absolute',
        right: 0,
    },
    filterContainer: {
        padding: theme.spacing(0),
        maxWidth: '120rem',
        width: '80vw',
        margin: theme.spacing(1, 'auto'),
    },
    headerContainer: {
        position: 'relative',
        fontSize: pxToRem(24),
        padding: theme.spacing(3, 0, 1, 0),
        maxWidth: '120rem',
        width: '80vw',
        margin: theme.spacing(0, 'auto'),
        right: theme.spacing(1),
    },
    closeIconContainer: {
        position: 'absolute',
        right: 0,
    },
    noResults: {
        display: 'flex',
        margin: theme.spacing(3, 'auto'),
    },
    notesHeaderContainer: {
        fontSize: theme.spacing(3),
    },
    notesHeader: {
        fontSize: 'inherit',
        fontWeight: 'bold',
    },
    horizontalRule: {
        position: 'relative',
        borderBottom: `2px solid ${dialogActionHR}`,
        width: '80vw',
        right: theme.spacing(1),
        maxWidth: '120rem',
        margin: theme.spacing(0, 'auto'),
    },
}))

export default useStyles
